import axios from "axios";
import { SOCKET_URL } from "../config";

export const makePlanPaymentAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${SOCKET_URL}/api/payment/initiate-tenant-payment`, data)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
